import styled, { css } from 'styled-components';
import { Favorite as HeartIcon } from '@mui/icons-material';

import { ReactComponent as TrashIcon } from '../../../../../../../assets/icons/v2/trash.svg';
import { ReactComponent as EditIcon } from '../../../../../../../assets/icons/v2/edit-blue.svg';

import { Card } from '../../../../../../../components/v2/Card';
import colors from '../../../../../../../styles/colors';

const iconStyle = css`
  width: 16px;
  height: 16px;
`;

const StyledCard = styled(Card)`
  display: flex;
  margin: 10px 0;
  padding: 20px;
  border-radius: 8px;
  background: ${colors.base.alpha};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  row-gap: 10px;
`;

const Message = styled.div`
  width: 100%;
  font-size: 15px;
`;

const TagContainer = styled.div`
  width: fit-content;
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DateText = styled.span`
  color: ${colors.shades.beta1};
  font-size: 12px;
`;

const LikesContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${colors.shades.beta1};
  font-size: 15px;
`;

const StyledHeartIcon = styled(HeartIcon)`
  color: ${colors.shades.primary4};
  font-size: 20px;
`;

const StyledTrashIcon = styled(TrashIcon)`
  ${iconStyle};
`;

const StyledEditIcon = styled(EditIcon)`
  ${iconStyle};
`;

export {
  StyledCard as Card,
  Message,
  TagContainer,
  BottomRow,
  DateText,
  LikesContainer,
  StyledHeartIcon as HeartIcon,
  StyledTrashIcon as TrashIcon,
  StyledEditIcon as EditIcon,
};
